import { Component, Input, OnInit } from "@angular/core"

@Component({
    selector: "app-read-more",
    templateUrl: "./read-more.component.html",
    styleUrls: ["./read-more.component.scss"],
    standalone: false,
})
export class ReadMoreComponent implements OnInit {
    // Info: By default, "Read More" button is shown, if any text comes from parent component
    public shouldDisplayReadMore: boolean = false
    public displayedText: string = ""

    @Input() public text: string = ""
    @Input() public displayedCharsLimit: number = 200

    public transformText(): string {
        if (this.shouldDisplayReadMore) {
            this.shouldDisplayReadMore = false
            return (this.displayedText = this.text)
        } else {
            this.shouldDisplayReadMore = true
            return (this.displayedText = this.text.substring(0, this.displayedCharsLimit) + "...")
        }
    }

    public ngOnInit() {
        this.displayedText = this.transformText()
    }
}
